// removed by extract-text-webpack-plugin
module.exports = {"list-box":"NewsItem__list-box__e6zZh","title":"NewsItem__title__211DJ","date":"NewsItem__date__333K5","source":"NewsItem__source__la7FP","visit":"NewsItem__visit__3AbrD","arrow-shaft":"NewsItem__arrow-shaft__3bKVK","arrow-icon":"NewsItem__arrow-icon__AgIkV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/News/NewsItem/NewsItem.scss
// module id = 456
// module chunks = 0